import find from "lodash/find";
import isEmpty from "lodash/isEmpty";

import {
  ENERGY_CLASS_VALUE_HASH,
  ENERGY_CLASS_LABEL_HASH,
  ENERGY_CLASS_SHEET_HASH,
  EXTERNAL_IMAGES_DOMAIN,
  EXTERNAL_FILES_DOMAIN,
} from "constants/ProductConstants";

import Image from "grandus-lib/components-atomic/image/Image";

import styles from "components/product/detail/energyLabel/EnergyLabel.module.scss";
import Link from "next/link";

const processUrl = function (url) {
  if (url.startsWith(EXTERNAL_FILES_DOMAIN)) {
    return "/external-files" + url.substring(EXTERNAL_FILES_DOMAIN.length);
  }

  return "/external-images" + url.substring(EXTERNAL_IMAGES_DOMAIN.length);
};

const isRewritableUrl = function (url) {
  return (
    url.startsWith(EXTERNAL_FILES_DOMAIN) ||
    url.startsWith(EXTERNAL_IMAGES_DOMAIN)
  );
};

const calculateParameterUrl = function (url) {
  if (isRewritableUrl(url)) {
    return [true, processUrl(url)];
  }

  return [false, url];
};

const EnergyLabel = ({ labels, parameters }) => {
  const paramValue = find(parameters, { hash: ENERGY_CLASS_VALUE_HASH });
  const paramLabel = find(parameters, { hash: ENERGY_CLASS_LABEL_HASH });
  const paramSheet = find(parameters, { hash: ENERGY_CLASS_SHEET_HASH });

  const label = find(labels, { name: paramValue?.value });

  if (isEmpty(label)) {
    return null;
  }

  const [isRewritableEnergyLabelUrl, energyLabelUrl] = calculateParameterUrl(
    paramLabel ? paramLabel?.value ?? "" : ""
  );
  const [isRewritableInformationUrl, informationListUrl] =
    calculateParameterUrl(paramLabel ? paramSheet?.value ?? "" : "");

  return (
    <div className={styles?.wrapper}>
      <Image photo={label?.photo} size={"155x80"} type={"png"} useNextImage />
      <div className={styles?.buttons}>
        {energyLabelUrl ? (
          <>
            {isRewritableEnergyLabelUrl ? (
              <Link href={energyLabelUrl} as={energyLabelUrl}>
                <a target="_blank">energetický štítok</a>
              </Link>
            ) : (
              <a target="_blank" href={energyLabelUrl}>
                energetický štítok
              </a>
            )}
          </>
        ) : null}

        {informationListUrl ? (
          <>
            {isRewritableInformationUrl ? (
              <Link href={informationListUrl} as={informationListUrl}>
                <a target="_blank">informačný list</a>
              </Link>
            ) : (
              <a target="_blank" href={informationListUrl}>
                informačný list
              </a>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default EnergyLabel;
